import type { RouteRecordRaw } from 'vue-router';

export const advertRoutes: Array<RouteRecordRaw> = [
  {
    path: '/advert',
    name: 'advert',
    redirect: '/advert/list',
    component: () => import('pages/info/advert/McAdvert.vue'),
    meta: {
      title: 'Adverts',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'advertList',
        component: () => import('pages/info/advert/AdvertList.vue'),
        meta: {
          title: 'Adverts List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'advertDetail',
        component: () => import('pages/info/advert/AdvertDetail.vue'),
        meta: {
          title: 'Advert Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'advertNew',
        component: () => import('pages/info/advert/AdvertNew.vue'),
        meta: {
          title: 'New Advert',
          requiresAuth: true,
        },
      },

      {
        path: 'cost',
        name: 'advertCost',
        component: () => import('pages/info/advert/advertCost/AdvertCostList.vue'),
        meta: {
          title: 'Advert Costs List',
          requiresAuth: true,
        },
      },
      {
        path: 'cost/detail/:itemId?',
        name: 'advertCostDetail',
        component: () => import('pages/info/advert/advertCost/AdvertCostDetail.vue'),
        meta: {
          title: 'Advert Cost Details',
          requiresAuth: true,
        },
      },
      {
        path: 'cost/new',
        name: 'advertCostNew',
        component: () => import('pages/info/advert/advertCost/AdvertCostNew.vue'),
        meta: {
          title: 'New Advert Cost',
          requiresAuth: true,
        },
      },

      {
        path: 'placement',
        name: 'advertPlacement',
        component: () => import('pages/info/advert/advertPlacement/AdvertPlacementList.vue'),
        meta: {
          title: 'Advert Placements List',
          requiresAuth: true,
        },
      },
      {
        path: 'placement/detail/:itemId?',
        name: 'advertPlacementDetail',
        component: () =>
          import('pages/info/advert/advertPlacement/AdvertPlacementDetail.vue'),
        meta: {
          title: 'Advert Placement Details',
          requiresAuth: true,
        },
      },
      {
        path: 'placement/new',
        name: 'advertPlacementNew',
        component: () => import('pages/info/advert/advertPlacement/AdvertPlacementNew.vue'),
        meta: {
          title: 'New Advert Placement',
          requiresAuth: true,
        },
      },

      {
        path: 'position',
        name: 'advertPosition',
        component: () => import('pages/info/advert/advertPosition/AdvertPositionList.vue'),
        meta: {
          title: 'Advert Positions List',
          requiresAuth: true,
        },
      },
      {
        path: 'position/detail/:itemId?',
        name: 'advertPositionDetail',
        component: () => import('pages/info/advert/advertPosition/AdvertPositionDetail.vue'),
        meta: {
          title: 'Advert Position Details',
          requiresAuth: true,
        },
      },
      {
        path: 'position/new',
        name: 'advertPositionNew',
        component: () => import('pages/info/advert/advertPosition/AdvertPositionNew.vue'),
        meta: {
          title: 'New Advert Position',
          requiresAuth: true,
        },
      },

      {
        path: 'click',
        name: 'advertClick',
        component: () => import('pages/info/advert/advertClick/AdvertClickList.vue'),
        meta: {
          title: 'Advert Clicks List',
          requiresAuth: true,
        },
      },
      {
        path: 'click/detail/:itemId?',
        name: 'advertClickDetail',
        component: () => import('pages/info/advert/advertClick/AdvertClickDetail.vue'),
        meta: {
          title: 'Advert Click Details',
          requiresAuth: true,
        },
      },
      {
        path: 'click/new',
        name: 'advertClickNew',
        component: () => import('pages/info/advert/advertClick/AdvertClickNew.vue'),
        meta: {
          title: 'New Advert Click',
          requiresAuth: true,
        },
      },

      {
        path: 'payment',
        name: 'advertPayment',
        component: () => import('pages/info/advert/advertPayment/AdvertPaymentList.vue'),
        meta: {
          title: 'Advert Payments List',
          requiresAuth: true,
        },
      },
      {
        path: 'payment/detail/:itemId?',
        name: 'advertPaymentDetail',
        component: () => import('pages/info/advert/advertPayment/AdvertPaymentDetail.vue'),
        meta: {
          title: 'Advert Payment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'payment/new',
        name: 'advertPaymentNew',
        component: () => import('pages/info/advert/advertPayment/AdvertPaymentNew.vue'),
        meta: {
          title: 'New Advert Payment',
          requiresAuth: true,
        },
      },
    ],
  },
];
